<template>
	<div class="detail">
		<Tou></Tou>
		<el-breadcrumb class="w1500 pt-30" separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
			<!-- <el-breadcrumb-item :to="{ path: '/forum' }">Forum</el-breadcrumb-item> -->
			<el-breadcrumb-item :to="{ path: '/post' }">Post</el-breadcrumb-item>
			<el-breadcrumb-item>{{tzshu.theme}}</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- <div> -->
		<div class="w1500 rel detail_nr br-10 mt-30 bj-0 pt-45 pb-45 pl-60 pr-60" style="">
			<div class="tit-30 B-700 ys-33 montserMedium">{{tzshu.theme}}</div>
			<div class="flex a-center B-100 mt-26">
				<!-- <el-image fit="contain" class="" :src="require('@/assets/pc/detail1.png')" alt="" /> -->
				<!-- <el-image fit="contain" class="" :src="'http://goodwe.jsydl.com.cn:9200/'+tzshu.avatar" alt="" /> -->
				<div class="tit-18"
					style="width:30px;height: 30px;text-align: center;line-height: 30px;color: white;border-radius: 50%; flex-shrink: 0;"
					:style="avatarStyle">{{avatarText}}</div>
				<div class="tit-16 ys-77 ml-10 montserLight"> <span>{{gudingziduan.forum.By}} {{tzshu.nickName}}</span> <el-divider
						direction="vertical"></el-divider>
						 <!-- <span>Total amount of reward:{{tzshu.integral}}</span> -->
					<el-divider direction="vertical"></el-divider> <span>{{gudingziduan.forum.Created}} {{tzshu.createTime}}</span><el-divider
						direction="vertical"></el-divider> <span>{{gudingziduan.forum.Lastreply}} {{tzshu.latestReplyTime}}</span>
				</div>
				<el-image v-if="tzshu.rewardPrice>0" fit="contain" class="ml-9" style="width: .2rem;height: .2rem;" :src="require('@/assets/xuanshan.png')" alt="" />
			</div>
			<el-divider class="mt-30 mb-44"></el-divider>
			<div class="mb-58 tit-16 ner ys-33 montserLight tneirong" v-html="tzshu.content">
			</div>
			<div class="flex flex-wrap">
				<div class="flex mr-37 a-center tit-15 ys-9a mb-10" v-for="l in tzshu.attachments"
					v-if="tzshu.attachments">
					<i class="iconfont icon-wenjianlianjie mr-10 tit-24 montserLight" v-if="l.name"></i>
					{{l.name}}
				</div>
			</div>
			<el-divider class="mt-27 mb-35"></el-divider>
			<div class="flex" style="align-items: center;justify-content: center;width: 100%;">
				<div @click="$houtui()" class="userProfile-right-btn3 more1 tit-17 ys-33 B-300 "><span class="iconfont icon-fanhui mr-8"></span>{{gudingziduan.xinzengde.Back}}</div>
			</div>
		</div>
		<div style="height:3rem;width: 100%;"></div>
		<!-- </div> -->
		<Foot></Foot>
	</div>

</template>

<script>
	import Tou from '../../../zuzuzu/touss.vue'
	import Bianjiqi from '../../../zujian/wangEditor.vue'
	import Foot from '../../../zuzuzu/foot.vue'
	import {allUser} from '@/api/user.js';
	import {
		detailsxq,
		detailscomments,
		fabucomment,
		pinglundianzan,
		tiezidianzan,
		tiezishoucang,
		tielie,
		tiezidashang
	} from '@/api/formdetails.js';
	export default {
		data() {
			return {
				zhuangtai: {
					zt1: false,
					zt2: false,
					zt3: false
				},
				dashanx: false,
				shu: {},
				comments: [
					// {
					// 	username: 'Champion',
					// 	date: '2022年8月11日13:58:58',
					// 	content: '今日事今日毕',
					// 	delete: true, //删除按钮显示
					// 	flag: false,
					// 	like: '',
					// 	display: true, //显示评论区
					// 	Like: 3,
					// 	Reply: 3,
					// 	Reward: 3,
					// 	numbers: 3,
					// 	responses: [{
					// 		username: '张二噶',
					// 		date: '2022年8月11日13:58:58',
					// 		content: '春有百花秋有月，夏有凉风冬有雪',
					// 		delete: true, //删除按钮是否显示
					// 		like: 1,
					// 		display: true,
					// 		picture: 'https://fuss10.elemecdn.com/1/34/19aa98b1fcb2781c4fba33d850549jpeg.jpeg',
					// 		to_username: 'Champion',
					// 		Like: 3,
					// 		Reply: 3,
					// 		Reward: 3,
					// 		numbers: 3 //点赞数
					// 	}, {
					// 		username: '伍六七',
					// 		date: '2022年8月11日14:18:26',
					// 		content: '千人同心则得千人力，万人异心则无一人之用',
					// 		delete: true,
					// 		display: true,
					// 		picture: 'https://fuss10.elemecdn.com/0/6f/e35ff375812e6b0020b6b4e8f9583jpeg.jpeg',
					// 		to_username: 'Champion',
					// 		Like: 3,
					// 		Reply: 3,
					// 		Reward: 3,
					// 		numbers: 3 //点赞数
					// 	}, {
					// 		username: '秦小二',
					// 		date: '2022年8月11日14:18:26',
					// 		content: '百年修得同船渡，千年修得共枕眠',
					// 		delete: true,
					// 		display: true,
					// 		picture: 'https://fuss10.elemecdn.com/3/28/bbf893f792f03a54408b3b7a7ebf0jpeg.jpeg',
					// 		to_username: 'Champion',
					// 		Like: 3,
					// 		Reply: 3,
					// 		Reward: 3,
					// 		numbers: 3 //点赞数
					// 	}, ]
					// },
					// {
					// 	username: 'Champion',
					// 	date: '2022年8月11日13:58:58',
					// 	content: '今日事今日毕',
					// 	delete: true, //删除按钮显示
					// 	flag: false,
					// 	like: '',
					// 	display: true, //显示评论区
					// 	Like: 3,
					// 	Reply: 3,
					// 	Reward: 3,
					// 	numbers: 3
					// },
				],
				sos: {
					jitiao: 6,
					ye: 0
				},
				zongshu: 60,
				targetPage: '',
				height: [],
				caozuoindex: -1,
				caozuoindex2: -1,
				xihuan: false,
				tzid: '',
				tzshu: {
					// theme: 'Goodwee Homekit 3000',
					// createTime: 'Created 2024-10-16',
					// content: 'Goodwee HomekitGoodwee HomekitGoodwee Homekit',
					// thumbsUpNum: '1',
					// collectNum: '2'
				},
				showReply: {}, // 用于存储父评论的回复框显示状态  
				showSubReply: {}, // 用于存储子评论的回复框显示状态  \
				pinglunhuifu: '',
				tiezilie: [],
				tieindex: 0,
				gerenxinxi:{},
				denglu: false,
				myshux:{},
				dashangjifeng: 0,
				gradients: [
					['#FDEB71', '#F8D800'],
					['#ABDCFF', '#0396FF'],
					['#FEB692', '#EA5455'],
					['#CE9FFC', '#7367F0'],
					['#90F7EC', '#32CBCB'],
					['#FFF6B7', '#F6416C'],
					['#81FBB8', '#28C76F'],
					['#E2B0FF', '#9F44D3'],
					['#F97794', '#623AA2'],
					['#FCCF31', '#F55555'],
					['#F761A1', '#8C1BAB'],
					['#43CBFF', '#9708CC'],
					['#5EFCE8', '#736EFE'],
					['#FAD7A1', '#E96D71'],
					['#FFD26F', '#3677FF'],
					['#A0FE65', '#FA016D'],
					['#FFDB01', '#0E197D'],
					['#FEC163', '#DE4313'],
					['#92FFC0', '#002661'],
					['#EEAD92', '#6018DC'],
					['#F6CEEC', '#D939CD'],
					['#52E5E7', '#130CB7'],
					['#F1CA74', '#A64DB6'],
					['#E8D07A', '#5312D6'],
					['#EECE13', '#B210FF'],
					['#79F1A4', '#0E5CAD'],
					['#FDD819', '#E80505'],
					['#FFF3B0', '#CA26FF'],
					['#FFF5C3', '#9452A5'],
					['#F05F57', '#360940'],
					['#2AFADF', '#4C83FF'],
					['#FFF886', '#F072B6'],
					['#97ABFF', '#123597'],
					['#F5CBFF', '#C346C2'],
					['#FFF720', '#3CD500'],
					['#FF6FD8', '#3813C2'],
					['#EE9AE5', '#5961F9'],
					['#FFD3A5', '#FD6585'],
					['#C2FFD8', '#465EFB'],
					['#FD6585', '#0D25B9'],
					['#FD6E6A', '#FFC600'],
					['#65FDF0', '#1D6FA3'],
					['#6B73FF', '#000DFF'],
					['#FF7AF5', '#513162'],
					['#F0FF00', '#58CFFB'],
					['#FFE985', '#FA742B'],
					['#FFA6B7', '#1E2AD2'],
					['#FFAA85', '#B3315F'],
					['#72EDF2', '#5151E5'],
					['#FF9D6C', '#BB4E75'],
					['#F6D242', '#FF52E5'],
					['#69FF97', '#00E4FF'],
					['#3B2667', '#BC78EC'],
					['#70F570', '#49C628'],
					['#3C8CE7', '#00EAFF'],
					['#FAB2FF', '#1904E5'],
					['#81FFEF', '#F067B4'],
					['#FFA8A8', '#FCFF00'],
					['#FFCF71', '#2376DD'],
					['#FF96F9', '#C32BAC'],
					// 这里可以添加更多的颜色组合  
				],
				colorCache:{},
				gudingziduan: {}
			}
		},
		components: {
			Tou,
			Bianjiqi,
			Foot
		},
		watch: {
		    '$store.state.cunyuanyan': {
		      handler(newValue, oldValue) {
		        // console.log('语言已更新:', newValue);
		        this.gudingziduan=this.$store.state.cunyuanyan
				// console.log(this.gudingziduan,'video')
		      },
		      deep: true // 如果 cunyuanyan 是对象，需要设置 deep 为 true
		    }
		},
		created() {
			if(this.$qu('yulangshu')){
				this.tzshu=this.$qu('yulangshu')
			}
			this.$store.commit('Gaiyuyan', this.$store.state.yuyan);
			this.gudingziduan=this.$store.state.cunyuanyan
			// console.log(this.gudingziduan,'preview_details ')
			// this.tzid = this.$route.query.id;
			// this.tiezhixiangqing()
			// this.pinglun(-1)
			if(!this.$qu('kouling')){
				allUser().then(s=>{
					if(s.code!=200){
					}
				})
			}
		},
		computed: {
			avatarText() {
				// 提取首字或首字母  
				return this.tzshu.nickName ? this.tzshu.nickName.charAt(0).toUpperCase() : '?';
			},
			avatarStyle() {
				return {
					background: this.getRandomGradient(),
				}
			},
			// avatarStyle2() {
			// 	return {
			// 		background: this.getRandomGradient(),
			// 	}
			// },
			avatarStyle3() {
				return {
					background: this.getRandomGradient(),
				}
			}
		},

		mounted() {
			if (this.comments[0] && this.comments[0].isShow == true) {
				// this.$nextTick(() => {
				this.$set(this.height, 0, this.$refs[`myElement${0}`][0].offsetHeight + 'px')
				// });
			}
			if(this.$qu('yonghuming').length==0 && this.$qu('kouling').length==0){
				this.denglu = false
			}else {
				this.denglu = true
			}
		},
		methods: {
			//打赏积分
			increment() {
				if(this.dashangjifeng<this.myshux.pointNum){
					this.dashangjifeng++;
				}
			},
			decrement() {
				if (this.dashangjifeng > 0) {
					this.dashangjifeng--;
				}
			},
			guanbidas(){
				this.dashanx=false
			},
			Dashangs(e){
				var dsshu={}
				// type为 1对应帖子id，为2是对应评论id
				// if(e){
				// 	dsshu.id=e.id
				// 	dsshu.type=2
				// }else{
					dsshu.id=this.tzshu.userId
					dsshu.type=1
				// }
				dsshu.invitationId=this.tzshu.id
				dsshu.num=this.dashangjifeng
				tiezidashang(dsshu).then(shu=>{
					// this.$message(shu.message);
					if(shu.code==200){
						this.dashanx=false
						this.$message({
						  showClose: true,
						  message:shu.message,
						  type: 'success',
						  offset:'350',
						  duration:0
						});
					}
					this.tiezhixiangqing()
				})
			},
			// 发布评论
			Fabu(e,i) {
				if(this.denglu) {
					const pinlunshu = {}
					pinlunshu.invitationId = this.tzid;
					pinlunshu.replyUserId = '';
					// console.log(e)
					if (e && e.id) {
						pinlunshu.content = this.pinglunhuifu;
						pinlunshu.replyUserId = e.userId;
						pinlunshu.pid = e.id;
					} else {
						pinlunshu.content = this.shu.Content;
						pinlunshu.pid = null;
						pinlunshu.replyUserId = this.tzshu.userId;
					}
					pinlunshu.persons = '';
					// console.log(pinlunshu)
					fabucomment(pinlunshu).then(shu => {
						if (shu.result == 'SUCCESS') {
							// this.$xiaoxi(shu.message)
							// this.$message(shu.message);
							this.shu.Content=''
							this.pinglunhuifu=''
							this.$message({
							  showClose: true,
							  message:shu.message,
							  type: 'success',
							  offset:'350',
							  duration:0
							});
							this.tiezhixiangqing()
							
							this.sos.ye=0
							if(e){
								if(e.id){
									this.$set(this.showReply, e.id, !this.showReply[e.id]);
								}
							  this.zhankai(i)
							  this.pinglun(e,i)
							}else{
								this.pinglun()
							}
							// location.reload();
						}
					})
				}else {
					this.$alert('Please log in first', '', {
					  confirmButtonText: 'Log in',
					  confirmButtonClass:'Loginanniu',
					  distinguishCancelAndClose:true,
					  center:true,
					  roundButton:true,
					  callback: action => {
						  if(action=='confirm'){
								this.$dakai('/login_in')
						  }
					  }
					});
					// this.$message({
					//   showClose: true,
					//   iconClass:'el-icon-warning',
					//   customClass:'my-error-message',
					//   dangerouslyUseHTMLString: true,
					//   message:'<strong><i style="margin-left:.1rem;">Please log in first</i> <a href="https://community.goodwe.com/login_in" style="color:red;margin-left:4px;text-decoration: none;">[here]</i> </strong>',
					//   type: 'error',
					//   offset:'350',
					//   duration:0
					// });
				}
			},
			toggleReply(e, indexs) {
				const commentId = e.id;
				this.$set(this.showReply, commentId, !this.showReply[commentId]);
				// console.log(this.showReply)
			},
			pinglun(e,i) { //分页查看评论
				detailscomments({
					'invitationId': this.tzid,
					'pid': null,
					'pageNum': this.sos.ye,
					'pageSize': this.sos.jitiao,
					"userId": this.tzshu.userId
				}).then(shu => { //分页查看帖子评论
					this.comments = shu.data.content
					if(e && e!=-1){
						const pinglunboxIndex = this.comments.indexOf(e);
						const pinglunbox = this.$refs['pinglunbox_' + pinglunboxIndex][0];
						 if (pinglunbox) {
							pinglunbox.scrollIntoView({ behavior:'smooth' });
						 }
						 
					}else{
						 if(e!=-1){
							const draftBox = this.$refs.pinglunbox;
							if (draftBox) {
								draftBox.scrollIntoView({ behavior:'smooth' });
							}
						 }
					}
				})
			},
			shangye() {
				// if (this.tieindex > 0) {  
				// 	this.tieindex--;  
				// this.tzid=this.tiezilie[this.tieindex].id
				this.tzid = this.tzshu.previousInvitation.id
				this.tiezhixiangqing()
				// }
			},
			xiaye() {
				// if (this.tieindex < this.tiezilie.length - 1) {  
				// this.tieindex++;
				// this.tzid=this.tiezilie[this.tieindex].id
				this.tzid = this.tzshu.nextInvitation.id
				this.tiezhixiangqing()
				// }  
			},
			// 相同组类型帖子
			// Xtieliw(e){
			// 	tielie({'gid':e,'ye':0,'jitiao':10}).then(shu=>{
			// 		this.tiezilie=shu.data.content
			// 		this.tieindex =this.tiezilie.findIndex(post => post.id ===this.tzshu.id);
			// 		// console.log(this.tieindex+'测呃呃呃')
			// 	})
			// },
			tiezhixiangqing() {
				detailsxq(this.tzid).then(shu => { //帖子详情
					const prefix = "http://goodwe.jsydl.com.cn:9200";
					this.tzshu = shu.data
					this.zongshu = shu.data.commentNum

					this.tzshu.attachments = this.tzshu.attachments.split(',').map(file => {
						const trimmedPath = file.trim();
						const fileName = trimmedPath.split('/').pop(); // 提取文件名  
						return {
							url: prefix + trimmedPath,
							name: fileName
						};
					});
					// this.Xtieliw(this.tzshu.groupId)
				})
			},
			hoverItem(index) {
				// 更新hoverStates对象中对应索引的hover状态  
				setTimeout(() => {
					this.hoverStates = this.resoulie[index].tu
				}, 600)
				// this.$set(this.hoverStates, this.resoulie[index].tu); // 使用$set确保响应性  

			},
			zhankai(i) {
				this.comments[i].isShow = true
				this.$nextTick(() => {
					this.$set(this.height, i, this.$refs[`myElement${i}`][0].offsetHeight + 'px')
				});
			},
			shouqi(i) {
				this.comments[i].isShow = false
				this.$set(this.height, i, 0)
			},
			likai() {
				this.leiming = 'likai'
				setTimeout(() => {
					this.leiming = ''
				}, 600)
			},
			getHoverImage(index) {
				// 根据hover状态返回相应的图片路径  
				return this.hoverStates[index] ? this.list[index].hoverImg : this.list[index].img;
			},
			caozuo(e, i) {
				if(this.denglu) {
					this.caozuoindex = e
					this.caozuoindex2 = i
					let pingluntype = ''
					let shoucantype = ''
					let dianzantype = ''
					if (e == 1) {
						if (this.comments[i].Likezt == true) {
							this.$set(this.comments[i], 'Like', this.comments[i].Like - 1)
							this.$set(this.comments[i], 'Likezt', false)
							this.$set(this.comments[i], 'isLike', false)
							pingluntype = 'thumbsUp'
						} else {
							this.$set(this.comments[i], 'Like', this.comments[i].Like + 1)
							this.$set(this.comments[i], 'Likezt', true)
							this.$set(this.comments[i], 'isLike', true)
							pingluntype = 'thumbsUp'
						}
						pinglundianzan({
							'avaliable': this.comments[i].isLike,
							'invitationId': this.comments[i].id,
							'type': pingluntype
						}).then(shu => {
							// this.$message(shu.message);
							this.$message({
							  showClose: true,
							  message:shu.message,
							  type: 'success',
							  offset:'350',
							  duration:0
							});
							this.pinglun()
							this.tiezhixiangqing()
							location.reload();
						})
						// console.log(this.comments[i].Likezt)
					} else if (e == 2) {
						this.$set(this.comments[i], 'Reply', this.comments[i].Reply + 1)
					} else if (e == 3) {
						this.$set(this.comments[i], 'Reward', this.comments[i].Reward + 1)
					} else if (e == 5 || e == 6) {
						// 点赞帖子
						if (e == 5) {
							if (this.tzshu.isLike == true) {
								this.$set(this.tzshu, 'isLike', false)
								dianzantype = 'thumbsUp'
							} else if (this.tzshu.isLike == false) {
								this.$set(this.tzshu, 'isLike', true)
								dianzantype = 'thumbsUp'
							}
							// console.log(dianzantype)
							// console.log(this.tzshu)
							tiezidianzan({
								'avaliable': this.tzshu.isLike,
								'invitationId': this.tzshu.id,
								'type': dianzantype
							}).then(shu => {
								// this.$message(shu.message);
								this.$message({
								  showClose: true,
								  message:shu.message,
								  type: 'success',
								  offset:'350'
								});
								if (shu.code == 200) {
									this.tiezhixiangqing()
								}
							})
						} else {
							if (this.tzshu.isCollect == true) {
								this.$set(this.tzshu, 'isCollect', false)
								shoucantype = 'Collection'
							} else {
								this.$set(this.tzshu, 'isCollect', true)
								shoucantype = 'Collection'
							}
					
							tiezishoucang({
								'avaliable': this.tzshu.isCollect,
								'invitationId': this.tzshu.id,
								'type': shoucantype
							}).then(shu => {
								// this.$message(shu.message);
								this.$message({
								  showClose: true,
								  message:shu.message,
								  type: 'success',
								  offset:'350',
								  duration:0
								});
								this.tiezhixiangqing()
							})
						}
					}
				}else {
					// this.$message({
					//   showClose: true,
					//   iconClass:'el-icon-warning',
					//   customClass:'my-error-message',
					//   dangerouslyUseHTMLString: true,
					//   message:'<strong><i style="margin-left:.1rem;">Please log in first</i> <a href="https://community.goodwe.com/login_in" style="color:red;margin-left:4px;text-decoration: none;">[here]</i> </strong>',
					//   type: 'error',
					//   offset:'350',
					//   duration:0
					// });
					this.$alert('Please log in first', '', {
					  confirmButtonText: 'Log in',
					  confirmButtonClass:'Loginanniu',
					  distinguishCancelAndClose:true,
					  center:true,
					  roundButton:true,
					  callback: action => {
						  if(action=='confirm'){
								this.$dakai('/login_in')
						  }
					  }
					});
				}
				
				// console.log(this.comments[i].Reward)
			},
			dashang() {
				if(this.denglu) {
					this.dashanx=true
				}else {
					this.$alert('Please log in first', '', {
					  confirmButtonText: 'Log in',
					  confirmButtonClass:'Loginanniu',
					  distinguishCancelAndClose:true,
					  center:true,
					  roundButton:true,
					  callback: action => {
						  if(action=='confirm'){
								this.$dakai('/login_in')
						  }
					  }
					});
					// this.$message({
					//   showClose: true,
					//   iconClass:'el-icon-warning',
					//   customClass:'my-error-message',
					//   dangerouslyUseHTMLString: true,
					//   message:'<strong><i style="margin-left:.1rem;">Please log in first</i> <a href="https://community.goodwe.com/login_in" style="color:red;margin-left:4px;text-decoration: none;">[here]</i> </strong>',
					//   type: 'error',
					//   offset:'350',
					//   duration:0
					// });
				}
			},
			handleCurrentChange(e) {},
			handleSizeChange(e) {},
			goToPage() {
				this.handleCurrentChange(this.sos.ye)
			},
			getFirstLetter(name) {
				// return name.charAt(0).toUpperCase(); // 返回第一个字母并转换为大写  
				return name ? name.charAt(0).toUpperCase() : '?';
			},
			getRandomGradient() {
				// 随机选择一个渐变组合  
				const randomGradient = this.gradients[Math.floor(Math.random() * this.gradients.length)];
				return `linear-gradient(135deg, ${randomGradient[0]}, ${randomGradient[1]})`;
			},
			getRandomGradient2(z,e, pindex) {
				const gradient = [];
				const userId = z.userId;
				if (this.colorCache[userId]) {
					return `background:linear-gradient(135deg, ${this.colorCache[userId][0]}, ${this.colorCache[userId][1]})`;
				}
				if (Number(e) >= 0) {
					if (pindex >= 0) {
						const gradientIndex = (e + pindex + this.comments.length) % this.gradients.length;
						this.gradient = this.gradients[gradientIndex];
					} else {
						this.gradient = this.gradients[e % this.gradients.length];
					  this.colorCache[userId] = this.gradient;
					}
					return `background:linear-gradient(135deg, ${this.gradient[0]}, ${this.gradient[1]})`;
				}
			}
		}
	}
</script>

<style lang="scss">
	body {
		background-color: #f6f7f8 !important;

	}
	.userProfile-right-btn3 {
		display: inline-block;
		padding: .12rem .52rem;
		border-radius: 100px;
		border: 1px solid #e50012;
		box-sizing: border-box;
		color: #fff;
	}
	// 打赏弹框
	.Reward_kuan1 {
		position: fixed;
		z-index: 9999;
		width: 100%;
		height: 100%;
		top: 0;
		background: rgba(0, 0, 0, 0.5);
		display: block;
	}

	.Reward_kuan2 {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;

		.Reward_kuan2_1 {
			background-color: #ffffff;
			border-radius: 20px;
			width: 38.6%;
			padding: 35px 48px 47px 48px;

			.Reward_kuan2_1_1 {
				border-bottom: 1px solid #e6e6e6;
				position: relative;
				padding-bottom: 7px
			}
		}

		.Rewardanniu {
			display: inline-block;
			background: linear-gradient(87deg, #ff785c 0%, #e70a16 100%);
			border-radius: 50px;
			margin: 0 auto;
		}

		.Rewardanniu3 {
			display: inline-block;
			border-radius: 50px;
			margin: 0 auto;
			border: solid 1px #e60012;
		}
		.jifencounter {  
		    display: flex;  
		    align-items: center;  
			margin-left: 17%;
		}  
		
		.jifencount-input {  
		    width: 50px;  
		    text-align: center;  
		    border: 1px solid #ccc;  
		    border-radius: 4px;  
		    margin: 0 10px;  
		    font-size: 16px;  
		}  
	}

	.w-e-text-container {
		height:100px !important;
	}

	.z-FF071C {
		color: #FF071C;
	}

	.bj-E6 {
		background: #E60012;
	}

	.detail {
		.youbian {
			right: 0;
			top: 8%;
			transform: translateX(130%);

			.youtub {
				width: .56rem;
				height: .56rem;
				min-height: 40px;
				min-width: 40px;
			}
		}



		.fanye.el-button:hover {
			background: linear-gradient(87deg, #ff785c 0%, #e70a16 100%) !important;
			color: #fff !important;
		}

		.fanye .fypage {
			display: flex;
			align-items: center;
			max-width: 48%;
		}

		.hover_h:hover {
			background: linear-gradient(87deg, #ff785c 0%, #e70a16 100%) !important;
			color: #fff !important;
		}

		.detail_nr {
			.el-image {
				width: 36px;
				flex-shrink: 0;
			}

			.ner {}

			.fanye .fypage .el-button {
				background: #EEEEEE;
				border-color: #EEEEEE;
				color: #333333;
				font-size: 14px;
				width: 94px;
				height: 34px;
				padding: 0;
				flex-shrink: 0;
			}

			.anniu .el-button {
				padding: .15rem .35rem;
				background: linear-gradient(87deg, #ff785c 0%, #e70a16 100%);
				border-radius: 100px;
				color: #fff;
				border-color: transparent;
			}

			.w-e-text-container {
				min-height:100px !important;
			}
		}

		.pinglunqu {
			.flex1 {
				flex: 1;
			}

			.pinglun_lie {
				.item .first {
					flex-wrap: wrap;
				}

				.el-image {
					width: .58rem;
					height: .58rem;
					flex-shrink: 0;
				}
			}
		}

	}

	//下拉回复框
	.reply-box {
		width: 96% !important;
		margin-top: 10px;
		transition: max-height 0.4s ease-in-out;
		/* 添加缓慢下拉效果 */
		max-height: 2000px;
		/* 控制下拉框最大高度 */
		overflow: hidden;
		/* 超出部分隐藏 */
		background-color: #f5f5f5;
		border-radius: 20px;
	}

	textarea {
		width: 100%;
		min-height: 100px;
		background-color: #f5f5f5;
		outline: none;
		resize: none;
		border: 0;
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.3s;
	}

	.fade-enter,
	.fade-leave-to

	/* .fade-leave-active in <2.1.8 */
		{
		opacity: 0;
	}

	.tneirong img {
		width: 100%;
		height: auto;
	}

	// ==========================================================================================================================================================================
	// 响应式

	@media screen and (max-width: 1200px) {
		.detail_nr {
			width: 80%;
		}
	}

	@media screen and (max-width: 767px) {
		.detail_nr {
			width: 95%;
			display: flex;
			flex-direction: column;
		}

		.detail .detail_nr .el-image {
			display: none;
		}

		.detail_nr .fanye {
			margin-top: .5rem;
			flex-wrap: wrap;
			order: 2;
		}

		.detail .fanye .fypage {
			max-width: 100%;
		}

		.detail .youbian {
			position: relative;
			display: flex;
			justify-content: space-between;
			width: 100%;
			transform: none;
		
		}

		.detail .youbian .youge {
			margin-top: 0;
		}

		.detail .youbian .youtub {
			background: #EEEEEE;
		}

		.detail .youbian .youtub.bj-E6 {
			background: #E60012;
		}

		.detail .pinglunqu .pinglun_lie .el-image {
			width: 1rem;
			height: 1rem;
		}

		.detail .pinglunqu .flex1 {
			margin-top: .3rem;
			width: 100%;
			flex: none;
			max-width: 100%;
			margin-left: 0;
		}

		.first-content .info {
			flex-wrap: wrap;
		}

		.first-content .info .num {
			margin-right: .2rem;
		}

		.first-content .info .num:last-child {
			margin-right: 0;
		}

		.first-content .moreInfo .mr-55 {
			margin-right: 0;
		}
	}
</style>